import React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSection,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from 'components/ModalSheet'
import Button from 'components/Button'
import NumericInput from 'components/inputs/NumericInput'
import {
  BulkBundlePriceList,
  BundlePriceItem,
} from 'admin/bundle/components/BulkBundlePriceList'
import { BulkEditPriceViewModel } from './BulkEditPriceViewModel'

interface Props {
  vm: BulkEditPriceViewModel
}

export default observer(function BulkEditPriceDialog({ vm }: Props) {
  return (
    <ModalSheet
      disableCloseOnOutsideClick
      showing={vm.showing}
      onRequestClose={vm.close}
    >
      <ModalSheetHeader bordered withCloseButton>
        <ModalSheetTitle>Edit price</ModalSheetTitle>
      </ModalSheetHeader>

      <ModalSheetContent>
        <BulkBundlePriceList rightHeader="New price">
          {vm.eligibleBundles.map((bundle) => (
            <BundlePriceItem
              key={bundle.Id}
              name={bundle.name}
              currentPrice={bundle.price}
              dataTest={`bulk-edit-price-row-${bundle.name}`}
              right={
                <NumericInput
                  aria-label={`New price for ${bundle.name}`}
                  mode="draft"
                  precision={2}
                  currencyCode="USD"
                  value={vm.priceFor(bundle.Id)}
                  onChange={(price) => vm.setPrice(bundle.Id, price)}
                  dataTest={`bulk-edit-price-input-${bundle.name}`}
                />
              }
            />
          ))}
        </BulkBundlePriceList>
      </ModalSheetContent>

      <ModalSheetFooter>
        {!vm.hasEligibleBundles ? (
          <ModalSheetFooterSection>
            All selected bundles are archived and can’t be repriced.
          </ModalSheetFooterSection>
        ) : (
          vm.hasArchivedBundles && (
            <ModalSheetFooterSection>
              {vm.archivedCount} archived{' '}
              {vm.archivedCount === 1 ? 'bundle' : 'bundles'} excluded.
            </ModalSheetFooterSection>
          )
        )}
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            type="default"
            onClick={vm.close}
            disabled={vm.submit.pending}
            dataTest="bulk-edit-price-close-button"
          >
            Close
          </Button>

          <Button
            type="primary"
            onClick={vm.submit}
            loading={vm.submit.pending}
            disabled={!vm.canApply || vm.submit.pending}
            dataTest="bulk-edit-price-submit-button"
          >
            Save prices
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
